export default class SubscriberNotificationService {
  constructor(apiService) {
    this.apiService = apiService
  }

  delete(id, idSubscriber, params) {
    return this.apiService.callDelete('me/subscribers/notifications/' + id, params)
  }
}



// WEBPACK FOOTER //
// ./src/service/SubscriberNotificationService.js